var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:['s-align-5 relative', ("radio-switch-" + _vm.color), { 'none-events': _vm.disabled }],style:({ height: (_vm.height + "px"), width: _vm.width == 'auto' ? 'auto' : (_vm.width + "px") })},[_vm._t("default"),_c('span',{class:[
        'radio-switch-mask s-align-5', 
        _vm.padding > 0 ? ("ph-" + _vm.padding) : '',
        { 'pointer' : !_vm.disabled }
    ]},[_vm._v("\n        "+_vm._s(_vm.label)+"\n    ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }